import { safeApiRequest } from './apiClient';

export const fetchKargoFirmalari = () =>
  safeApiRequest('/api/kargo-firmalari', { method: 'GET' });

export const createKargoFirmasi = (body) =>
  safeApiRequest('/api/kargo-firmalari', { method: 'POST', body });

export const updateKargoFirmasi = (id, body) =>
  safeApiRequest(`/api/kargo-firmalari/${encodeURIComponent(id)}`, { method: 'PUT', body });

/** @param {string[]} kargoFirmaIds — yeni sıra (ilk öğe en üstte) */
export const reorderKargoFirmalari = (kargoFirmaIds) =>
  safeApiRequest('/api/kargo-firmalari/sira', { method: 'PUT', body: { kargoFirmaIds } });

export const deleteKargoFirmasi = (id) =>
  safeApiRequest(`/api/kargo-firmalari/${encodeURIComponent(id)}`, { method: 'DELETE' });
